import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { SessionService } from '@unity/services/session.service';

@Injectable({
  providedIn: 'root',
})
export class MyAgencyResolver implements Resolve<string> {
  private readonly sessionService = inject(SessionService);

  public resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return this.sessionService.$currentAgencyId()?.toString() ?? '';
  }
}
